/*

  Modificado por Pista e Campo:
  - FIX 1: limpa o carrinho fantasma após cada cotação (impede acúmulo de itens que inflava o frete)
  - FIX 2: guard contra duplo clique / cotações simultâneas
  - FIX 3: shippingCalcButton e calculandoFrete no escopo do módulo (eram inacessíveis em getRates)
  - FIX 4: resetCartCookie seguro quando não há cookie original
  - Lógica de CEP, variantId, data e formato de moeda mantidos idênticos ao original
*/
(function () {

    "use strict";

    var debug = false;
    var cartCookie;

    /* A console logging function */
    var log = function (a) {
        if (!debug) { return }
        console.log(a);
    };

    /* The ID of the element that you want to add the shipping fields into */
    var productSection = document.getElementsByClassName('frete-produto');
    if (!productSection.length) { log('Could not find the element'); return }

    /* the main product select element */
    var productSelect = document.getElementById('ProductSelect-product-template');
    if (!productSelect) { productSelect = document.getElementsByName('id')[0]; }
    if (!productSelect) { log('Could not find the main select element'); return }

    /* create a message box */
    var shippingMessage  = document.createElement('p');
    var shippingCountry  = document.createElement('select');
    var shippingProvince = document.createElement('select');
    var shippingZip      = document.createElement('input');
    var freteLista       = document.createElement('div');

    /* FIX 3: declarados no escopo do módulo para serem acessíveis em getRates e liberarBotao */
    var shippingCalcButton;
    var calculandoFrete = false;

    /* Erro Frete */
    shippingMessage.classList.add('erros-fretes');
    shippingMessage.setAttribute("style", "display:none");

    /* Ajustes da lista de fretes */
    freteLista.classList.add('listas-de-fretes');
    freteLista.setAttribute("style", "display:none");

    /* FIX 2: libera o botão e a flag — chamado ao fim de qualquer fluxo */
    var liberarBotao = function () {
        calculandoFrete = false;
        if (shippingCalcButton) {
            shippingCalcButton.style.opacity = '';
            shippingCalcButton.style.pointerEvents = '';
        }
    };

    /* get cookie by name */
    var getCookie = function (name) {
        var value = "; " + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length == 2) return parts.pop().split(";").shift();
    };

    /* update the cart cookie value */
    var updateCartCookie = function (a) {
        log('changing cart cookie value to: ' + a);
        var date = new Date();
        date.setTime(date.getTime() + (14 * 86400000));
        var expires = '; expires=' + date.toGMTString();
        document.cookie = 'cart=' + a + expires + '; path=/';
    };

    /* FIX 4: reset seguro — se não havia cookie original, expira o fake em vez de gravar undefined */
    var resetCartCookie = function () {
        if (cartCookie) {
            updateCartCookie(cartCookie);
        } else {
            document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        }
        log(getCookie('cart'));
    };

    /* FIX 1: limpa o carrinho fantasma antes de restaurar o cookie */
    var limparCarrinhoFantasma = function (addData, callback) {
        var updates = {};
        if (addData.items) {
            addData.items.forEach(function (item) { updates[item.id] = 0; });
        } else if (addData.id) {
            updates[addData.id] = 0;
        }
        fetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
        }).then(function () {
            callback();
        }).catch(function () {
            callback(); /* restaura o cookie mesmo se a limpeza falhar */
        });
    };

    /* get the rates */
    var getRates = function (variantId) {

        $('.listas-de-fretes').html("");
        $('.listas-de-fretes').show();

        if (typeof variantId === 'undefined') { liberarBotao(); return }

        /* the main quantity element */
        var productQuantity = document.getElementById('Quantity');
        var quantity = productQuantity ? parseInt(productQuantity.value) : 1;

        /* FIX 1: suporte a kit form (vários itens) — mantendo estrutura do antigo para produto simples */
        var addData;
        var kitForm = document.querySelector('.add-to-cart-form--kit');

        if (kitForm) {
            addData = { items: [] };
            var formData = new FormData(kitForm);
            if (formData.get('id')) {
                addData.items.push({
                    id: parseInt(formData.get('id')),
                    quantity: parseInt(formData.get('quantity') || 1)
                });
            } else {
                var itemsMap = {};
                for (var pair of formData.entries()) {
                    var matchId  = pair[0].match(/items\[(\d+)\]\[id\]/);
                    var matchQty = pair[0].match(/items\[(\d+)\]\[quantity\]/);
                    if (matchId)  { if (!itemsMap[matchId[1]])  itemsMap[matchId[1]]  = {}; itemsMap[matchId[1]].id       = pair[1]; }
                    if (matchQty) { if (!itemsMap[matchQty[1]]) itemsMap[matchQty[1]] = {}; itemsMap[matchQty[1]].quantity = pair[1]; }
                }
                Object.keys(itemsMap).forEach(function (k) {
                    if (itemsMap[k].id) addData.items.push({ id: parseInt(itemsMap[k].id), quantity: parseInt(itemsMap[k].quantity || 1) });
                });
            }
            if (addData.items.length === 0) { liberarBotao(); return; }
        } else {
            /* produto simples — estrutura idêntica ao original */
            addData = { id: variantId, quantity: quantity };
        }

        /* Finalização: limpa fantasma → restaura cookie → libera botão */
        var finalizar = function () {
            limparCarrinhoFantasma(addData, function () {
                resetCartCookie();
                liberarBotao();
            });
        };

        fetch('/cart/add.js?_easygift_internal=true', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest'
            },
            method: 'POST'
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            console.log("Itens simulados adicionados ao carrinho fantasma:", json);

            $.ajax({
                type: "GET",
                url: '/cart/shipping_rates.json?_easygift_internal=true',
                data: {
                    'shipping_address[country]': shippingCountry.value,
                    'shipping_address[province]': shippingProvince.value,
                    'shipping_address[zip]': shippingZip.value
                },
                beforeSend: function () {
                    $('.listas-de-fretes').html("<img id='loading-icon-frete' src='https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543' width='30px' style='width:30px; height: 30px; margin:0 auto'>");
                },
                success: function (d) {
                    if (d.shipping_rates && d.shipping_rates.length) {
                        for (var i = 0; i < d.shipping_rates.length; i++) {

                            var valorFrete = d.shipping_rates[i].price;
                            /* com centavos, igual ao checkout */
                            if (valorFrete == "0.00" || valorFrete == null) {
                                valorFrete = "Grátis";
                            } else {
                                valorFrete = Shopify.formatMoney(valorFrete, 'R$ {{amount_with_comma_separator}}');
                            }

                            /* estimativa em dias úteis calculados a partir da delivery_date */
                            var deliveryDate = d.shipping_rates[i].delivery_date;
                            var entregaStr = "";
                            if (deliveryDate != null) {
                                var hoje = new Date();
                                hoje.setHours(0,0,0,0);
                                var dataEstimadaAPI = new Date(deliveryDate);
                                dataEstimadaAPI.setHours(0,0,0,0);
                                var diasEstimados = 0;
                                var dataTemp = new Date(hoje.getTime());
                                while (dataTemp < dataEstimadaAPI) {
                                    dataTemp.setDate(dataTemp.getDate() + 1);
                                    if (dataTemp.getDay() !== 0 && dataTemp.getDay() !== 6) { diasEstimados++; }
                                }
                                diasEstimados += 1; /* +1 dia de preparo */
                                entregaStr = diasEstimados > 0 ? "(Estimativa de entrega: <b>" + diasEstimados + " dias úteis</b>)" : "(Pronta entrega)";
                            }

                            $('<div class="frete-item"> <div> <p class="m-0 nome-frete"><b>' + d.shipping_rates[i].name + '</b> <span class="estimativa-de-entrega">' + entregaStr + '</span></p> </div><div class="frete-valor">Valor: <b> ' + valorFrete + '</b></div> </div>').appendTo('.listas-de-fretes');
                        }

                        $('#loading-icon-frete').remove();
                        console.log("Removido");
                    }
                    finalizar();
                },
                error: function () {
                    $('.listas-de-fretes').html("");
                    shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                    shippingMessage.setAttribute("style", "display:flex");
                    finalizar();
                },
                dataType: 'json'
            }).fail(function () {
                console.error('$.ajax falhou ao buscar shipping_rates');
                finalizar();
            });

        }).catch(function (err) {
            console.error(err);
            finalizar();
        });

    };

    /* We are just adding some dummy fields for example only. There's better ways to handle this */
    var initFields = function () {

        /* create the country picker */
        shippingCountry.id = "pais-simulator";
        var countries = ['Brazil'];
        for (var i = 0; i < countries.length; i++) {
            shippingCountry.add(new Option(countries[i], countries[i], i === 0));
        }
        shippingCountry.name = 'shipping_address[country]';

        /* create the province state picker */
        shippingProvince.id = "estados-simulator";
        var provinces = ['Acre', 'Alagoas', 'Amapa', 'Amazonas', 'Bahia', 'Ceara', 'Distrito Federal', 'Espirito Santo', 'Goias', 'Maranhao', 'Mato Grosso', 'Mato Grosso do Sul', 'Minas Gerais', 'Para', 'Paraiba', 'Parana', 'Pernambuco', 'Piaui', 'Rio de Janeiro', 'Rio Grande do Norte', 'Rio Grande do Sul', 'Rondonia', 'Roraima', 'Santa Catarina', 'Sao Paulo', 'Sergipe', 'Tocantins'];
        for (var i = 0; i < provinces.length; i++) {
            shippingProvince.add(new Option(provinces[i], provinces[i], i === 0));
        }
        shippingProvince.name = 'shipping_address[province]';

        /* create the zip / postcode field */
        shippingZip.type = 'text';
        shippingZip.name = 'shipping_address[zip]';
        shippingZip.className = 'Form__Input cep-calculo-frete form-control';
        shippingZip.placeholder = 'Digite seu CEP';
        $(shippingZip).mask("00.000-000");

        /* create a wrapper for the fields */
        var shippingCalcWrapper = document.createElement('div');
        shippingCalcWrapper.className = 'shipping-calc-wrapper';

        /* create a wrapper for the fields */
        var formularioFrete = document.createElement('div');
        formularioFrete.className = 'formulario-frete';

        /* create a title */
        var shippingCalcTitle = document.createElement('p');
        shippingCalcTitle.innerText = 'Simule seu frete';

        /* create a get rates button */
        /* FIX 3: atribuído à variável do escopo do módulo (não var local) */
        shippingCalcButton = document.createElement('a');
        shippingCalcButton.innerText = 'Calcular';
        shippingCalcButton.className = 'btn btn-underline button--primary button';
        shippingCalcButton.onclick = function () {

            /* FIX 2: impede duplo clique */
            if (calculandoFrete) { return; }
            calculandoFrete = true;
            shippingCalcButton.style.opacity = '0.6';
            shippingCalcButton.style.pointerEvents = 'none';

            var cepLimpo = shippingZip.value.replace(/\D/g, '');

            shippingMessage.innerHTML = '';
            shippingMessage.setAttribute("style", "display:none");

            /* Processa os dados do CEP (vindo do ViaCEP ou BrasilAPI) e dispara a cotação */
            var processarDados = function (dados) {

                switch (dados.uf) {
                    case 'AC': dados.uf = 'Acre'; break;
                    case 'AL': dados.uf = 'Alagoas'; break;
                    case 'AP': dados.uf = 'Amapa'; break;
                    case 'AM': dados.uf = 'Amazonas'; break;
                    case 'BA': dados.uf = 'Bahia'; break;
                    case 'CE': dados.uf = 'Ceara'; break;
                    case 'DF': dados.uf = 'Distrito Federal'; break;
                    case 'ES': dados.uf = 'Espirito Santo'; break;
                    case 'GO': dados.uf = 'Goias'; break;
                    case 'MA': dados.uf = 'Maranhao'; break;
                    case 'MT': dados.uf = 'Mato Grosso'; break;
                    case 'MS': dados.uf = 'Mato Grosso do Sul'; break;
                    case 'MG': dados.uf = 'Minas Gerais'; break;
                    case 'PA': dados.uf = 'Para'; break;
                    case 'PB': dados.uf = 'Paraiba'; break;
                    case 'PR': dados.uf = 'Parana'; break;
                    case 'PE': dados.uf = 'Pernambuco'; break;
                    case 'PI': dados.uf = 'Piaui'; break;
                    case 'RJ': dados.uf = 'Rio de Janeiro'; break;
                    case 'RN': dados.uf = 'Rio Grande do Norte'; break;
                    case 'RS': dados.uf = 'Rio Grande do Sul'; break;
                    case 'RO': dados.uf = 'Rondonia'; break;
                    case 'RR': dados.uf = 'Roraima'; break;
                    case 'SC': dados.uf = 'Santa Catarina'; break;
                    case 'SP': dados.uf = 'Sao Paulo'; break;
                    case 'SE': dados.uf = 'Sergipe'; break;
                    case 'TO': dados.uf = 'Tocantins'; break;
                }

                shippingProvince.value = dados.uf;

                /* lógica de cookie idêntica ao original */
                if (!productSelect.value.length) { console.log("Nenhuma variação selecionada"); }
                cartCookie = getCookie('cart');
                var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
                var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();

                if (!cartCookie) {
                    log('no cookie found');
                    updateCartCookie(tempCookieValue);
                    cartCookie = getCookie('cart');
                } else {
                    log('cookie found');
                }

                if (cartCookie && cartCookie.length < 32) { log('cart ID not valid'); liberarBotao(); return }

                updateCartCookie(fakeCookieValue);
                log(getCookie('cart'));

                /* lógica de variantId idêntica ao original */
                if (!productSelect.value.length) {
                    getRates(parseInt($(productSelect).find('option').get(1).value));
                } else {
                    getRates(parseInt(productSelect.value));
                }
            };

            /* Tenta ViaCEP primeiro. CEPs gerais de cidade (ex: 62800-000) podem retornar
               {"erro":true} no ViaCEP — nesses casos usa BrasilAPI como fallback,
               que suporta CEPs gerais e retorna pelo menos o state (UF) necessário. */
            $.getJSON("https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?", function (dados) {

                if (!("erro" in dados)) {
                    /* CEP encontrado normalmente no ViaCEP */
                    processarDados(dados);
                    return;
                }

                /* ViaCEP retornou erro — tenta BrasilAPI como fallback (suporta CEPs gerais)
                   BrasilAPI usa CORS puro, não JSONP — usa fetch em vez de $.getJSON */
                fetch("https://brasilapi.com.br/api/cep/v2/" + cepLimpo)
                    .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
                    .then(function (br) {
                        if (br && br.state) {
                            processarDados({ uf: br.state });
                        } else {
                            liberarBotao();
                        }
                    })
                    .catch(function () { liberarBotao(); });

            }).fail(function () {
                /* ViaCEP inacessível — tenta BrasilAPI como fallback */
                fetch("https://brasilapi.com.br/api/cep/v2/" + cepLimpo)
                    .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
                    .then(function (br) {
                        if (br && br.state) {
                            processarDados({ uf: br.state });
                        } else {
                            $('.listas-de-fretes').html("");
                            shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                            shippingMessage.setAttribute("style", "display:flex");
                            liberarBotao();
                        }
                    })
                    .catch(function () {
                        $('.listas-de-fretes').html("");
                        shippingMessage.innerHTML = 'Cep não encontrado, tente novamente.';
                        shippingMessage.setAttribute("style", "display:flex");
                        liberarBotao();
                    });
            });

        };

        /* create some labels for the fields */
        var labelNames = ['País', 'Estado', 'CEP'];
        var labels = [];
        for (var i = 0; i < labelNames.length; i++) {
            var label = document.createElement('label');
            label.innerText = labelNames[i];
            labels.push(label);
        }

        /* link "Não sei meu CEP" (alinhado à direita do campo) */
        var naoLembroLink = document.createElement('a');
        naoLembroLink.href = 'https://buscacepinter.correios.com.br/app/endereco/index.php';
        naoLembroLink.target = '_blank';
        naoLembroLink.rel = 'noopener noreferrer';
        /* Buybox v2 by🔥Pista (2026-07): texto e visual conforme mockup —
           cinza claro, sem sublinhado, alinhado à direita */
        naoLembroLink.innerText = 'Não lembro meu CEP';
        naoLembroLink.className = 'nao-lembro-cep';
        naoLembroLink.style.cssText = 'display:block; text-align:right; font-size:12px; margin-top:6px; color: #9ca3af; text-decoration:none; cursor:pointer;';

        shippingCalcWrapper.appendChild(formularioFrete);
        formularioFrete.appendChild(shippingCountry);
        formularioFrete.appendChild(shippingProvince);
        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(shippingCalcButton);
        shippingCalcWrapper.appendChild(naoLembroLink);
        shippingCalcWrapper.appendChild(shippingMessage);
        shippingCalcWrapper.appendChild(freteLista);

        /* add to the page */
        productSection[0].appendChild(shippingCalcWrapper);
    };

    initFields();

})();